import React from 'react';

const Page404 = ({ location }) => (
    <div>
        <h2>Page <code>{location.pathname}</code> not found.</h2>
    </div>
)

export default Page404